export enum SalesChannelTypeEnum {
  Kiosk = 'Kiosk',
  Web = 'Web',
  Pos = 'Pos',
  App = 'App',
}
